exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btndel[data-v-553807f2]{position:absolute;z-index:1;width:20px !important;height:20px !important;left:46px;top:-4px}.pictrue[data-v-553807f2]{width:60px;height:60px;border:1px dotted rgba(0,0,0,.1);margin-right:10px;position:relative;cursor:pointer}.pictrue img[data-v-553807f2]{width:100%;height:100%}", ""]);

// exports
